
import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import Countdown from 'react-countdown';
import 'react-slideshow-image/dist/styles.css';
import '../Helper/links';
import { _endPoints, getapartments, getbookingscheck } from "../Helper/links";
import { pattern } from '../Helper/pattern';
import API from "../Helper/server/API";
import { InvoiceContext } from '../bookings/invoice/Invoice_Context';
import InvoiceBookingesReport from "../bookings/invoice/invoice_bookinges_report";
import { View_count_days, View_price_day } from "../constants/dataView";
import before_days from "../functions/print_date_before_days";
import view_apartment_type_ar from "../functions/view_apartment_type";
import view_day_ar from "../functions/view_day_ar";
import empty from '../public/svg/empty.svg';
import '../public/themes/saga-blue/theme.css';

function ReportCheck() {

    const toast = useRef(null);
    const Completionist = () => <span>تم الغاء الحجز</span>;
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [year, setYear] = useState(new Date());

    //_____________________________________________________________________
    const [apartments, setApartments] = useState([]);
    const [apartments_view, setApartments_view] = useState([]);
    const paid_type = ['all', 'paid', 'not_paid'];
    const [paid_type_view, setPaidTypeView] = useState('all');
    //_____________________________________________________________________
    const [reservationes, set_reservationes] = useState([]);
    const [reservationes_check_in, set_reservationes_check_in] = useState([]);
    const [reservationes_check_out, set_reservationes_check_out] = useState([]);

    const [loading_reservationes_view, set_loading_reservationes_view] = useState(false);
    const [data_show, set_data_show] = useState({
        ID_reservation: true,
        visitor_name: true,
        phone_number: true,
        ID_apartment: true,
        date_check_in: true,
        days: true,
        price_day: true,
        total_price: true,
        total_paid: true,
        card_paid: true,
        rest: true,
        discount_value: true,
        notes: true,
        date_create: true,
        username: true,
        footer_total_price: true,
        footer_total_paid: true,
        footer_total_rest: true,
        footer_total_discount_value: false,
    });
    const [loading_apartment, set_loading_apartment] = useState(false);
    //_____________________________________________________________________
    const [selectedReservationes, setSelectedReservationes] = useState([]);
    //______________________________________________________________________
    const [date_check, set_date_check] = useState(new Date());
    const [name_phone, setname_phone] = useState("");
    const [ID_reservation, setID_reservation] = useState("");
    const [disabled_search, set_disabled_search] = useState(false);
    //_______________________________________________________________________
    const statusBodyTemplate = (reservation) => {
        if (reservation.total_price - reservation.total_paid === 0) {
            return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "17px" }}
                value={"خالص"} severity="success">
            </Tag>;
        }
        else {
            return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "17px" }}
                value={reservation.total_price - reservation.total_paid + "د.ل"} severity="danger">
            </Tag>;
        }
    };
    const ID_reservationBodyTemplate = (reservation) => {
        var diffInMs = new Date(moment(reservation.date_del_reservation).format("yyyy-MM-DD")) - new Date(moment(new Date()).format("yyyy-MM-DD"));
        var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        return (
            <>
                {reservation.ID_reservation}

                {

                    reservation.date_del_reservation ?
                        <span style={{ color: "red" }}>
                            <br></br>
                            <Countdown date={reservation.date_del_reservation}
                                renderer={renderer}
                            >
                            </Countdown>
                            <br></br>
                            {diffInDays > 0 ? diffInDays + " آيــام " : null}
                        </span>
                        : null
                }
            </>
        );
    };
    const ApartmentBodyTemplate = (reservation) => {
        return (
            <>
                {view_apartment_type_ar(reservation.type) + "-" + reservation.number + " "}
            </>
        );
    };
    const PhoneTemplate = (reservation) => {
        return (
            <>
                <a href={"tel:+218" + reservation.phone_number}>{reservation.phone_number}</a>
                <br></br>
                <a href={"tel:+218" + reservation.whatsapp_number}>{reservation.whatsapp_number}</a>
            </>
        );
    };

    const Date_CheckInBodyTemplate = (reservation) => {
        return (
            <>
                {moment(reservation.date_check_in).format("YYYY-MM-DD")}
                <br></br>
                {view_day_ar(reservation.date_check_in)}
            </>
        );
    };
    const Date_CheckOutBodyTemplate = (reservation) => {
        return (
            <>
                {moment(reservation.date_check_out).format("YYYY-MM-DD")}
                <br></br>
                {view_day_ar(reservation.date_check_out)}
            </>
        );
    };
    const Total_PriceBodyTemplate = (reservation) => {
        return reservation.total_price + "د.ل";
    };


    const Total_PaidBodyTemplate = (reservation) => {
        return reservation.total_paid === 0 ? "-" : reservation.total_paid + "د.ل";
    };
    const Total_discound_valueBodyTemplate = (reservation) => {
        if (reservation.discount_value > 0) {
            return (
                <p>{reservation.discount_value + " د.ل"}</p>
            );
        }
        else {
            return 0;
        }

    };
    const DateCreate_BodyTemplate = (reservation) => {
        return (
            <p>
                {before_days(reservation.date_create)}
                <br></br>
                {moment(reservation.date_create).format("LT")}
            </p>
        );
    };
    const CustomerTemplate = (reservation) => {
        return (
            <>
                {data_show.visitor_name ? reservation.visitor_name : null}
                {
                    data_show.phone_number ?
                        <>
                            <br></br>
                            <a style={{ color: "#495057" }} href={"tel:+218" + reservation.phone_number}>{reservation.phone_number}</a>
                            <br></br>
                            {reservation.whatsapp_number && reservation.whatsapp_number !== "null" ?
                                <>
                                    <a style={{ color: "#495057" }} href={"tel:+" + reservation.whatsapp_number} dir="ltr">{reservation.whatsapp_number}</a>
                                    <i className="fa fa-whatsapp pr-1" style={{ color: "green", width: "2px" }}></i>
                                </>
                                :
                                <></>
                            }
                        </> : null
                }
            </>
        );
    };
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <span>
                {hours}:{minutes}:{seconds}

            </span>;
        }
    };
    //____________________________________________________________
    const [Invoice, setInvoice] = useState(false);
    const [ShowCofigReport, setShowCofigReport] = useState(false);


    //____________________________________________________________
    const handel_ID_reservation = (e) => {
        if (pattern.number_int.test(e.target.value) === true) {
            setID_reservation(e.target.value);
            set_disabled_search(true);
        }
        else if (e.target.value === '' || e.target.value === null) {
            setID_reservation(e.target.value);
            set_disabled_search(false);
        }
    }
    const renderHeader = (check) => {
        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-10">
                        <div className="flex justify-content-between" style={{ fontFamily: "Cairo", fontSize: "15px" }} dir="rtl">
                            <div className="row">
                                <div className="col-md-4 pl-0 ">
                                    <label id="lvisitor_name">تــاريخ  {check == "out" ? <> المغــادرة </> : <> الدخـــول </>}   *
                                        <i className="pi pi-calendar pr-1" ></i>
                                    </label>
                                    <label id="msg_customer" style={{ paddingRight: "50px" }}></label>
                                    <Calendar locale="ar" readOnlyInput hideOnRangeSelection placeholder="تاريخ الدخول"
                                        value={date_check} onChange={(e) => set_date_check(e.value)} dateFormat="yy-mm-dd" showButtonBar
                                        style={{ paddingRight: "0px", paddingLeft: "0px" }} panelStyle={{ width: "auto" }} disabled={disabled_search} />
                                </div>
                                <div className="col-md-2 p-0 mt-1">
                                    <Button
                                        type="button"
                                        icon="fa fa-search ml-2" label="عــــرض"
                                        outlined
                                        onClick={(e) => GetAllReservationes(date_check, check)}
                                        style={{ marginTop: "25px" }}
                                        disabled={
                                            loading_reservationes_view || loading_apartment ?
                                                true : false
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-2" style={{ textAlign: "left" }}>
                        <Button
                            type="button" severity="secondary"
                            icon="fa fa-cog ml-2" label="تعــديل التقــرير"
                            outlined
                            onClick={(e) => setShowCofigReport(true)}
                            style={{ marginTop: "25px" }}

                        />
                    </div>
                </div>

            </div>
        );
    };

    const renderHowShow = () => {
        return (
            <div className="col-md-12">
                <center>
                    <hr></hr>
                    <h6>بيانات الحجز</h6>
                    <hr></hr>
                </center>
                <div className="row">
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>رقم الحجز</label>
                            <Button icon={data_show.ID_reservation ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.ID_reservation ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.ID_reservation ? { ...data_show, ID_reservation: false } : { ...data_show, ID_reservation: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>اسم العميل</label>
                            <Button icon={data_show.visitor_name ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.visitor_name ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.visitor_name ? { ...data_show, visitor_name: false } : { ...data_show, visitor_name: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> رقم العميل</label>
                            <Button icon={data_show.phone_number ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.phone_number ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.phone_number ? { ...data_show, phone_number: false } : { ...data_show, phone_number: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> الاقامة</label>
                            <Button icon={data_show.ID_apartment ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.ID_apartment ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.ID_apartment ? { ...data_show, ID_apartment: false } : { ...data_show, ID_apartment: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-2 col-4 mb-2">
                        <center>
                            <label>الدخول والمغادرة</label>
                            <Button icon={data_show.date_check_in ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.date_check_in ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.date_check_in ? { ...data_show, date_check_in: false } : { ...data_show, date_check_in: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> عدد الايام</label>
                            <Button icon={data_show.days ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.days ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.days ? { ...data_show, days: false } : { ...data_show, days: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>سعر اليوم</label>
                            <Button icon={data_show.price_day ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.price_day ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.price_day ? { ...data_show, price_day: false } : { ...data_show, price_day: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> الاجمالي</label>
                            <Button icon={data_show.total_price ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.total_price ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.total_price ? { ...data_show, total_price: false } : { ...data_show, total_price: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> المدفوع</label>
                            <Button icon={data_show.total_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.total_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.total_paid ? { ...data_show, total_paid: false } : { ...data_show, total_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label> طريقة الدفع</label>
                            <Button icon={data_show.card_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.card_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.card_paid ? { ...data_show, card_paid: false } : { ...data_show, card_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>الباقي</label>
                            <Button icon={data_show.rest ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.rest ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.rest ? { ...data_show, rest: false } : { ...data_show, rest: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>التخفيض</label>
                            <Button icon={data_show.discount_value ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.discount_value ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.discount_value ? { ...data_show, discount_value: false } : { ...data_show, discount_value: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>ملاحظات</label>
                            <Button icon={data_show.notes ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.notes ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.notes ? { ...data_show, notes: false } : { ...data_show, notes: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-1 col-4 mb-2">
                        <center>
                            <label>وقت الحجز</label>
                            <Button icon={data_show.date_create ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.date_create ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.date_create ? { ...data_show, date_create: false } : { ...data_show, date_create: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-2 col-4 mb-2">
                        <center>
                            <label>الحجز عن طريق</label>
                            <Button icon={data_show.username ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.username ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.username ? { ...data_show, username: false } : { ...data_show, username: true })} className="col-md-12" />
                        </center>
                    </div>
                </div>
                <hr></hr>
                <div className="row">
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المبلغ</label>
                            <Button icon={data_show.footer_total_price ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_price ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_price ? { ...data_show, footer_total_price: false } : { ...data_show, footer_total_price: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المدفوع</label>
                            <Button icon={data_show.footer_total_paid ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_paid ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_paid ? { ...data_show, footer_total_paid: false } : { ...data_show, footer_total_paid: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي المتبقي</label>
                            <Button icon={data_show.footer_total_rest ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_rest ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_rest ? { ...data_show, footer_total_rest: false } : { ...data_show, footer_total_rest: true })} className="col-md-12" />
                        </center>
                    </div>
                    <div className="col-md-3 col-3 mb-2">
                        <center>
                            <label>إجمالي التخفيض</label>
                            <Button icon={data_show.footer_total_discount_value ? "pi pi-check pl-1" : "pi pi-times pl-1"} outlined severity={data_show.footer_total_discount_value ? "success" : "danger"}
                                onClick={(e) => set_data_show(data_show.footer_total_discount_value ? { ...data_show, footer_total_discount_value: false } : { ...data_show, footer_total_discount_value: true })} className="col-md-12" />
                        </center>
                    </div>

                </div>

            </div>
        );
    };

    const print = () => {
        setInvoice(true);
    };
    //_______________________________________________________________________________________
    //                      Get Reservationes

    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.apartments.get_apartments)
        if (response?.success === 1) {
            setApartments(response.data);
            setApartments_view(response.data);
        }
        set_loading_apartment(false);
    }
    const GetAllReservationes = async (year, check) => {
        set_loading_reservationes_view(true)

        const response = await API.get(`${getbookingscheck}?date_check=${moment(date_check).format('YYYY-MM-DD')}&check=${check == 'out' ? 'out' : 'in'}`)
        if (response?.success === 1) {
            if (check == 'out')
                set_reservationes_check_out(response?.data);
            else
                set_reservationes_check_in(response?.data);
        }
        else if (response?.success === 0) {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_view(false)
    }
    const ApartmentsViewItemTemplate = (apt) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl" }} >
                <span>{view_apartment_type_ar(apt.type)} - {apt.number}</span>
            </div>
        );
    };
    const PaidViewTemplate = (value) => {
        return (
            <>
                <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "13px", textAlign: "right", maxHeight: "22px" }}
                    value={value === 'all' ? 'الكل' : value === 'paid' ? "خالص" : "غير خالص"} severity={value === 'all' ? 'info' : value === 'paid' ? "success" : "danger"}>
                </Tag>
            </>
        );
    };
    const footer = () => {
        return (
            <>
                <div className="ibox-body" style={{ textAlign: "center", padding: "10px" }}>
                    <div className="row" style={{ fontSize: "15px" }}>
                        <div className="col-md-4" >
                            <strong className="col-md-10">   تحديد {selectedReservationes.length} حجوزات </strong>
                            <Button
                                dir="ltr"
                                type="button"
                                icon="pi pi-filter-slash"
                                text
                                severity="danger"
                                onClick={() => { setSelectedReservationes([]) }}
                            />
                        </div>
                        <div className="col-md-8">
                            <>
                                <div className="row">
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button icon="fa fa-print" dir="ltr" outlined label="طبــاعة " className="col-12" severity="secondary" aria-label="طباعة" onClick={print} disabled={selectedReservationes.length > 0 ? false : true} />
                                    </div>

                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    useEffect(() => {
        GetApartment();
        GetAllReservationes(new Date().getFullYear(), 'in');
        GetAllReservationes(new Date().getFullYear(), 'out');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="page-heading">
                    <h1 className="page-title"> تقـاريـر الحجــوزات </h1>
                </div>
                <div className="card">
                    <div class="clf" key={1}>
                        <ul class="nav nav-tabs tabs-line nav-fill">
                            <li class="nav-item">
                                <a class={"nav-link active"} href={`#tab-1`} data-toggle="tab">
                                    <h6>الدخـــول</h6>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class={"nav-link"} href={`#tab-2`} data-toggle="tab">
                                    <h6>المغــادرة</h6>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content mt-5">
                            <div class={"tab-pane show active"} id={`tab-1`}>
                                <div className='col-md-12'>
                                    {renderHeader('in')}
                                    <DataTable value={reservationes_check_in} loading={loading_reservationes_view}
                                        dataKey="ID_reservation"
                                        selectionMode="multiple" selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                                        metaKeySelection={false} dragSelection
                                        stripedRows removableSort
                                        paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                        scrollable scrollHeight="750px"
                                        sortMode="multiple"
                                        size="normal"
                                        footer={footer}
                                        emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                        tableStyle={{ minWidth: '50rem' }}
                                        style={{ fontFamily: "Cairo", direction: "rtl", border: "10px" }}
                                    >
                                        <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                        {data_show.ID_reservation ? <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '2%', textAlign: "right" }}></Column> : null}
                                        {data_show.visitor_name || data_show.phone_number ? <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.ID_apartment ? <Column field="number" header="الاقامة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                            body={ApartmentBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_check_in ? <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_check_in ? <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.days ? <Column field="date_check_in" header="الأيام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> : null}
                                        {data_show.price_day ? <Column field="total_price" header="سعر اليوم" body={View_price_day} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.total_price ? <Column field="total_price" header="الإجمالي" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.total_paid ? <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column> : null}
                                        {data_show.rest ? <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "red" }} ></Column> : null}
                                        {data_show.discount_value ? <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.notes ? <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_create ? <Column field="date_create" header="وثت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.username ? <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                    </DataTable>
                                </div>
                            </div>
                            <div class={"tab-pane"} id={`tab-2`}>
                                <div className='col-md-12'>
                                    {renderHeader('out')}
                                    <DataTable value={reservationes_check_out} loading={loading_reservationes_view}
                                        dataKey="ID_reservation"
                                        selectionMode="multiple" selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                                        metaKeySelection={false} dragSelection
                                        stripedRows removableSort
                                        paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                        scrollable scrollHeight="750px"
                                        sortMode="multiple"
                                        size="normal"
                                        footer={footer}
                                        emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                        tableStyle={{ minWidth: '50rem' }}
                                        style={{ fontFamily: "Cairo", direction: "rtl", border: "10px" }}
                                    >
                                        <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                        {data_show.ID_reservation ? <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '2%', textAlign: "right" }}></Column> : null}
                                        {data_show.visitor_name || data_show.phone_number ? <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.ID_apartment ? <Column field="number" header="الاقامة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                            body={ApartmentBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_check_in ? <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_check_in ? <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.days ? <Column field="date_check_in" header="الأيام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> : null}
                                        {data_show.price_day ? <Column field="total_price" header="سعر اليوم" body={View_price_day} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.total_price ? <Column field="total_price" header="الإجمالي" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.total_paid ? <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column> : null}
                                        {data_show.rest ? <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "red" }} ></Column> : null}
                                        {data_show.discount_value ? <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.notes ? <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column> : null}
                                        {data_show.date_create ? <Column field="date_create" header="وثت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                        {data_show.username ? <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column> : null}
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br></br>

                </div>
                <Dialog dir="rtl" header="تعديــل التقــرير" visible={ShowCofigReport} maximizable style={{ width: '80vw', fontFamily: "Cairo" }} onHide={() => setShowCofigReport(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    {renderHowShow()}
                </Dialog>
                {
                    Invoice ?
                        (
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={Invoice} maximizable style={{ width: '90vw', fontFamily: "Cairo" }} onHide={() => setInvoice(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                <InvoiceContext.Provider value={{
                                    reservations: selectedReservationes,
                                    data_show: data_show
                                }} >
                                    {Invoice && <InvoiceBookingesReport></InvoiceBookingesReport>}
                                </InvoiceContext.Provider>
                            </Dialog>
                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default ReportCheck


